<div>

    <input type="text" class="form-control" name="value" [(ngModel)]="value"  (ngModelChange)="onChange($event)"  />

    <div class="autocomplete-suggestion" *ngIf="filteredList.length > 0">

        <ul *ngFor="let item of filteredList">
            <li>
                <a (click)="select(item.SearchName)">{{item.SearchName}}</a>
            </li>
        </ul>
    </div>
    <!--<my-spinner [isRunning]="isRequesting"></my-spinner>-->
</div>
